export const MAP_CLICKED = 'mapAdmin/MAP_CLICKED';
export const MAP_ZOOM_END = 'mapAdmin/MAP_ZOOM_END';
